import { createFileRoute } from "@tanstack/react-router"
import { FinanceFundraisingPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/fundraising"
)({
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.READ}>
      <FinanceFundraisingPage />
    </AuthorizationGate>
  ),
})
